// import React, { useRef, useState, useMemo } from "react";
// import axios from "axios";
// import { MdError } from "react-icons/md";
// import { MdAutorenew } from "react-icons/md";
// import * as XLSX from "xlsx";
// import { formatSalesValue } from "../../../utils/formatUtils";
// import OutletSearch from "../../SelectSearch/OutletSearch";
// import Navbar from "../../Navbar";
// import Footer from "../../Footer";

// const TABS = ["Normal", "Aggregated"];

// const CostCenter = () => {
//   const Url = process.env.REACT_APP_BASE_URL;
//   const today = new Date().toLocaleDateString("en-CA");
//   const token = localStorage.getItem("token");

//   const [startDate, setStartDate] = useState(today);
//   const [endDate, setEndDate] = useState(today);
//   const [selectedOutlet, setSelectedOutlet] = useState("");

//   const [data, setData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("Normal");

//   const centerRefs = useRef({});

//   const handleCostCenter = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       setData([]);

//       const response = await axios.post(
//         `${Url}/costcenterwiseAllStockTransfers`,
//         {
//           outlet: selectedOutlet,
//           startDate,
//           endDate,
//         }
//       );

//       setData(response.data);
//     } catch (err) {
//       console.log("Error fetching data:", err);
//       setError(err?.response?.data?.error || err?.response?.data?.message || "Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ─── Aggregated: same structure, but items within each group are merged by ItemName ───
//   const aggregatedData = useMemo(() => {
//     return data.map((center) => ({
//       ...center,
//       GroupWiseItemDetails: center.GroupWiseItemDetails.map((group) => {
//         const map = {};

//         group.items.forEach((item) => {
//           const key = item.ItemName;
//           if (!map[key]) {
//             map[key] = {
//               ItemName: item.ItemName,
//               BrandName: item.BrandName,
//               UOM: item.UOM,
//               totalQty: 0,
//               weightedRateSum: 0,
//               Total: 0,
//             };
//           }
//           const qty = Number(item.Amount) || 0;
//           const rate = Number(item.Rate) || 0;
//           const total = Number(item.Total) || 0;
//           map[key].totalQty += qty;
//           map[key].weightedRateSum += qty * rate;
//           map[key].Total += total;
//         });

//         const aggregatedItems = Object.values(map).map((row) => ({
//           ...row,
//           avgRate: row.totalQty > 0 ? row.weightedRateSum / row.totalQty : 0,
//           aggregatedGroupTotal: Object.values(map).reduce((s, r) => s + r.Total, 0),
//         }));

//         const groupTotal = aggregatedItems.reduce((s, r) => s + r.Total, 0);

//         return { ...group, items: aggregatedItems, group_total: groupTotal };
//       }),
//     }));
//   }, [data]);

//   // Pick the right dataset based on active tab
//   const displayData = activeTab === "Aggregated" ? aggregatedData : data;

//   const handleExportExcel = () => {
//     if (!data.length || !selectedOutlet) return;

//     const wb = XLSX.utils.book_new();
//     const isAggregated = activeTab === "Aggregated";

//     // ── Summary sheet (grand totals never change between tabs) ──────────────
//     const summaryRows = [
//       ["Outlet", selectedOutlet],
//       ["From", startDate],
//       ["To", endDate],
//       [],
//       ["Cost Center", "Total"],
//     ];
//     let overallGrandTotal = 0;
//     data.forEach((center) => {
//       summaryRows.push([center.CostCenter, Number(center.grand_total)]);
//       overallGrandTotal += Number(center.grand_total || 0);
//     });
//     summaryRows.push([]);
//     summaryRows.push(["Grand Total", overallGrandTotal]);
//     const summaryWs = XLSX.utils.aoa_to_sheet(summaryRows);
//     summaryWs["!cols"] = [{ wch: 22 }, { wch: 15 }];
//     XLSX.utils.book_append_sheet(wb, summaryWs, "Summary");

//     // ── Per-cost-center sheets from displayData ──────────────────────────────
//     displayData.forEach((center) => {
//       const rows = [];
//       rows.push(["Outlet", selectedOutlet]);
//       rows.push(["From", startDate]);
//       rows.push(["To", endDate]);
//       rows.push([]);
//       rows.push(["Cost Center", center.CostCenter]);
//       if (isAggregated) rows.push(["View", "Aggregated"]);
//       rows.push([]);
//       rows.push([
//         "Group",
//         "Item",
//         "Brand",
//         "Qty",
//         "UOM",
//         isAggregated ? "Avg Rate" : "Rate",
//         "Total",
//       ]);

//       center.GroupWiseItemDetails.forEach((group) => {
//         rows.push([group.GroupName]);

//         group.items.forEach((item) => {
//           rows.push([
//             "",
//             item.ItemName,
//             item.BrandName || "-",
//             isAggregated
//               ? formatSalesValue(item.totalQty)
//               : formatSalesValue(item.Amount),
//             item.UOM,
//             isAggregated
//               ? formatSalesValue(item.avgRate)
//               : formatSalesValue(item.Rate),
//             formatSalesValue(item.Total),
//           ]);
//         });

//         rows.push([
//           "",
//           "",
//           "",
//           "",
//           "",
//           "Group Total",
//           formatSalesValue(group.group_total),
//         ]);
//         rows.push([]);
//       });

//       rows.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "Grand Total",
//         formatSalesValue(center.grand_total),
//       ]);

//       const ws = XLSX.utils.aoa_to_sheet(rows);
//       ws["!cols"] = [
//         { wch: 22 },
//         { wch: 25 },
//         { wch: 15 },
//         { wch: 10 },
//         { wch: 12 },
//         { wch: 14 },
//         { wch: 18 },
//       ];
//       XLSX.utils.book_append_sheet(
//         wb,
//         ws,
//         center.CostCenter.substring(0, 31)
//       );
//     });

//     const outletName = selectedOutlet.replace(/\s+/g, "_");
//     const tabSuffix = isAggregated ? "_aggregated" : "";
//     XLSX.writeFile(
//       wb,
//       `cost_center_${outletName}_${startDate}_${endDate}${tabSuffix}.xlsx`
//     );
//   };

//   const scrollToCenter = (name) => {
//     const el = centerRefs.current[name];
//     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   const overallGrandTotal = data.reduce(
//     (sum, c) => sum + Number(c.grand_total || 0),
//     0
//   );

//   // Shared renderer for both Normal and Aggregated — layout is identical
//   const renderCenterTables = (renderData, isAggregated) =>
//     renderData.map((center, idx) => (
//       <div
//         key={center.CostCenter}
//         ref={(el) => (centerRefs.current[center.CostCenter] = el)}
//         className="mb-5"
//       >
//         <div
//           key={idx}
//           className="max-w-5xl mx-auto border rounded-lg shadow-sm overflow-hidden"
//         >
//           <div className="bg-slate-500 text-white px-4 py-2 font-semibold">
//             Cost Center: {center.CostCenter}
//           </div>

//           <div className="max-h-[600px] overflow-y-auto border rounded tiny-scrollbar">
//             <table className="w-full text-sm">
//               <thead className="bg-slate-100 sticky top-0 z-10">
//                 <tr>
//                   <th className="px-3 py-2 text-left">Group</th>
//                   <th className="px-3 py-2 text-left">Item</th>
//                   <th className="px-3 py-2 text-left">Brand</th>
//                   <th className="px-3 py-2 text-right">Qty</th>
//                   <th className="px-3 py-2 text-left">UOM</th>
//                   <th className="px-3 py-2 text-right">
//                     {isAggregated ? "Avg Rate" : "Rate"}
//                   </th>
//                   <th className="px-3 py-2 text-right">Total</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {center.GroupWiseItemDetails.map((group, gIdx) => (
//                   <React.Fragment key={gIdx}>
//                     <tr className="bg-slate-200">
//                       <td colSpan={7} className="px-3 py-2 font-semibold text-slate-700">
//                         {group.GroupName}
//                       </td>
//                     </tr>

//                     {group.items.map((item, iIdx) => (
//                       <tr key={iIdx} className="border-t">
//                         <td className="px-3 py-2"></td>
//                         <td className="px-3 py-2">{item.ItemName}</td>
//                         <td className="px-3 py-2">{item.BrandName || "-"}</td>
//                         <td className="px-3 py-2 text-right">
//                           {isAggregated
//                             ? formatSalesValue(item.totalQty)
//                             : item.Amount}
//                         </td>
//                         <td className="px-3 py-2">{item.UOM}</td>
//                         <td className="px-3 py-2 text-right">
//                           {isAggregated
//                             ? formatSalesValue(item.avgRate)
//                             : formatSalesValue(item.Rate)}
//                         </td>
//                         <td className="px-3 py-2 text-right font-medium">
//                           {isAggregated
//                             ? formatSalesValue(item.Total)
//                             : formatSalesValue(item.Total)}
//                         </td>
//                       </tr>
//                     ))}

//                     <tr className="bg-slate-100 font-semibold">
//                       <td colSpan={6} className="px-3 py-2 text-right">
//                         Group Total
//                       </td>
//                       <td className="px-3 py-2 text-right">
//                         {formatSalesValue(group.group_total)}
//                       </td>
//                     </tr>
//                   </React.Fragment>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="flex justify-end max-w-5xl w-full mx-auto mt-2">
//           <div className="bg-slate-500 font-semibold rounded-lg py-2 px-3 text-white">
//             Grand Total: {formatSalesValue(center.grand_total)}
//           </div>
//         </div>
//       </div>
//     ));

//   return (
//     <div className="min-h-screen flex flex-col">
//       <Navbar />

//       <div className="flex-grow">
//         <div className="pt-4">
//           {/* Filters */}
//           <div className="max-w-5xl mx-auto mb-3">
//             <div className="flex justify-between items-center mb-3">
//               <div className="flex items-center gap-x-3">
//                 <label className="font-base font-poppins md:text-base">From:</label>
//                 <input
//                   type="date"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="text-xs md:text-base cursor-pointer border rounded px-3 py-2"
//                 />
//               </div>

//               <OutletSearch
//                 selectedOutlet={selectedOutlet}
//                 setSelectedOutlet={setSelectedOutlet}
//                 token={token}
//               />

//               <div className="flex items-center gap-x-3">
//                 <label className="font-base font-poppins md:text-base">To:</label>
//                 <input
//                   type="date"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="text-xs md:text-base cursor-pointer border rounded px-3 py-2"
//                 />
//               </div>
//             </div>

//             <div className="flex justify-between items-center">
//               <div className="flex-1 flex justify-start">
//                 <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden">
//                   {TABS.map((tab) => (
//                     <button
//                       key={tab}
//                       onClick={() => setActiveTab(tab)}
//                       disabled={data.length === 0 || loading || error}
//                       className={`px-5 py-2 text-sm font-medium transition-colors
//                         disabled:!bg-slate-100
//                         disabled:!text-slate-500
//                         disabled:!cursor-not-allowed
//                         disabled:!hover:bg-slate-100
//                         ${activeTab === tab
//                           ? "bg-slate-600 text-white"
//                           : "bg-white text-slate-600 hover:bg-slate-50"
//                         }`}
//                     >
//                       {tab}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="flex-1 flex justify-center">
//                 <button
//                   onClick={handleCostCenter}
//                   disabled={loading}
//                   className="px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm transition"
//                 >
//                   {loading ? "Loading..." : "Search"}
//                 </button>
//               </div>

//               <div className="flex-1 flex justify-end">
//                 <button
//                   onClick={handleExportExcel}
//                   disabled={!data.length}
//                   className="px-4 py-2 rounded-md font-medium bg-green-100 text-green-800 hover:bg-green-200 hover:shadow-md text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Export To Excel
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Loading */}
//           {loading && (
//             <div className="max-w-5xl mx-auto my-4 rounded-md bg-blue-50 p-4">
//               <div className="flex gap-3 justify-center">
//                 <MdAutorenew className="h-5 w-5 text-blue-500 animate-spin" />
//                 <div className="text-blue-700">Fetching cost center data...</div>
//               </div>
//             </div>
//           )}

//           {/* Error */}
//           {error && (
//             <div className="max-w-5xl mx-auto my-4 rounded-md bg-red-50 p-4">
//               <div className="flex gap-3 justify-center">
//                 <MdError className="h-5 w-5 text-red-400" />
//                 <div className="text-red-700">{error}</div>
//               </div>
//             </div>
//           )}

//           {!loading && data.length > 0 && (
//             <>
//               {/* Cost Center Summary — always visible */}
//               <div className="max-w-sm mx-auto mt-2 border rounded-lg overflow-hidden shadow-sm mb-4">
//                 <div className="bg-slate-600 text-white px-4 py-2 font-semibold">
//                   Cost Center Summary
//                 </div>
//                 <table className="w-full text-sm">
//                   <thead className="bg-slate-100">
//                     <tr>
//                       <th className="px-3 py-2 text-left">Cost Center</th>
//                       <th className="px-3 py-2 text-right">Total</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {data.map((center, i) => (
//                       <tr
//                         key={i}
//                         onClick={() => scrollToCenter(center.CostCenter)}
//                         className="border-t cursor-pointer hover:bg-slate-100"
//                       >
//                         <td className="px-3 py-2 font-medium text-blue-700 hover:underline">
//                           {center.CostCenter}
//                         </td>
//                         <td className="px-3 py-2 text-right">
//                           {formatSalesValue(center.grand_total)}
//                         </td>
//                       </tr>
//                     ))}
//                     <tr className="border-t bg-slate-200 font-semibold">
//                       <td className="px-3 py-2 text-left">Grand Total</td>
//                       <td className="px-3 py-2 text-right">
//                         {formatSalesValue(overallGrandTotal)}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>

//               {/* Tables — same layout, different data source */}
//               {renderCenterTables(displayData, activeTab === "Aggregated")}
//             </>
//           )}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default CostCenter;




import React, { useRef, useState, useMemo } from "react";
import axios from "axios";
import { MdError } from "react-icons/md";
import { MdAutorenew } from "react-icons/md";
import * as XLSX from "xlsx";
import { formatSalesValue } from "../../../utils/formatUtils";
import OutletSearch from "../../SelectSearch/OutletSearch";
import Navbar from "../../Navbar";
import Footer from "../../Footer";

const TABS = ["Normal", "Aggregated"];

const CostCenter = () => {
  const Url = process.env.REACT_APP_BASE_URL;
  const today = new Date().toLocaleDateString("en-CA");
  const token = localStorage.getItem("token");

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [selectedOutlet, setSelectedOutlet] = useState("");

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Normal");

  const centerRefs = useRef({});

  // The API returns a flat ItemDetailsList per cost center, with GroupName
  // on each item — it does NOT pre-group items the way the rest of this
  // component expects. Group it here into { GroupName, items, group_total }
  // buckets so downstream code (aggregation, tables, export) has one
  // consistent shape to work with, regardless of what the backend sends.
  const groupItemsByGroupName = (itemDetailsList = []) => {
    const groups = {};

    itemDetailsList.forEach((item) => {
      const key = item.GroupName || "UNGROUPED";
      if (!groups[key]) {
        groups[key] = { GroupName: key, items: [], group_total: 0 };
      }
      groups[key].items.push(item);
      groups[key].group_total += Number(item.Total) || 0;
    });

    return Object.values(groups);
  };

  const handleCostCenter = async () => {
    try {
      setLoading(true);
      setError(null);
      setData([]);

      const response = await axios.post(
        `${Url}/costcenterwiseAllStockTransfers`,
        {
          outlet: selectedOutlet,
          startDate,
          endDate,
        }
      );

      const raw = Array.isArray(response.data) ? response.data : [];
      const normalized = raw.map((center) => ({
        ...center,
        GroupWiseItemDetails: groupItemsByGroupName(center.ItemDetailsList),
      }));

      setData(normalized);
    } catch (err) {
      console.log("Error fetching data:", err);
      setError(err?.response?.data?.error || err?.response?.data?.message || "Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // ─── Aggregated: same structure, but items within each group are merged by ItemName ───
  const aggregatedData = useMemo(() => {
    return data.map((center) => ({
      ...center,
      GroupWiseItemDetails: (center.GroupWiseItemDetails || []).map((group) => {
        const map = {};

        group.items.forEach((item) => {
          const key = item.ItemName;
          if (!map[key]) {
            map[key] = {
              ItemName: item.ItemName,
              BrandName: item.BrandName,
              UOM: item.UOM,
              totalQty: 0,
              weightedRateSum: 0,
              Total: 0,
            };
          }
          const qty = Number(item.Amount) || 0;
          const rate = Number(item.Rate) || 0;
          const total = Number(item.Total) || 0;
          map[key].totalQty += qty;
          map[key].weightedRateSum += qty * rate;
          map[key].Total += total;
        });

        const aggregatedItems = Object.values(map).map((row) => ({
          ...row,
          avgRate: row.totalQty > 0 ? row.weightedRateSum / row.totalQty : 0,
          aggregatedGroupTotal: Object.values(map).reduce((s, r) => s + r.Total, 0),
        }));

        const groupTotal = aggregatedItems.reduce((s, r) => s + r.Total, 0);

        return { ...group, items: aggregatedItems, group_total: groupTotal };
      }),
    }));
  }, [data]);

  // Pick the right dataset based on active tab
  const displayData = activeTab === "Aggregated" ? aggregatedData : data;

  const handleExportExcel = () => {
    if (!data.length || !selectedOutlet) return;

    const wb = XLSX.utils.book_new();
    const isAggregated = activeTab === "Aggregated";

    // ── Summary sheet (grand totals never change between tabs) ──────────────
    const summaryRows = [
      ["Outlet", selectedOutlet],
      ["From", startDate],
      ["To", endDate],
      [],
      ["Cost Center", "Total"],
    ];
    let overallGrandTotal = 0;
    data.forEach((center) => {
      summaryRows.push([center.CostCenter, Number(center.grand_total)]);
      overallGrandTotal += Number(center.grand_total || 0);
    });
    summaryRows.push([]);
    summaryRows.push(["Grand Total", overallGrandTotal]);
    const summaryWs = XLSX.utils.aoa_to_sheet(summaryRows);
    summaryWs["!cols"] = [{ wch: 22 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, summaryWs, "Summary");

    // ── Per-cost-center sheets from displayData ──────────────────────────────
    displayData.forEach((center) => {
      const rows = [];
      rows.push(["Outlet", selectedOutlet]);
      rows.push(["From", startDate]);
      rows.push(["To", endDate]);
      rows.push([]);
      rows.push(["Cost Center", center.CostCenter]);
      if (isAggregated) rows.push(["View", "Aggregated"]);
      rows.push([]);
      rows.push([
        "Group",
        "Item",
        "Brand",
        "Qty",
        "UOM",
        isAggregated ? "Avg Rate" : "Rate",
        "Total",
      ]);

      (center.GroupWiseItemDetails || []).forEach((group) => {
        rows.push([group.GroupName]);

        group.items.forEach((item) => {
          rows.push([
            "",
            item.ItemName,
            item.BrandName || "-",
            isAggregated
              ? formatSalesValue(item.totalQty)
              : formatSalesValue(item.Amount),
            item.UOM,
            isAggregated
              ? formatSalesValue(item.avgRate)
              : formatSalesValue(item.Rate),
            formatSalesValue(item.Total),
          ]);
        });

        rows.push([
          "",
          "",
          "",
          "",
          "",
          "Group Total",
          formatSalesValue(group.group_total),
        ]);
        rows.push([]);
      });

      rows.push([
        "",
        "",
        "",
        "",
        "",
        "Grand Total",
        formatSalesValue(center.grand_total),
      ]);

      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws["!cols"] = [
        { wch: 22 },
        { wch: 25 },
        { wch: 15 },
        { wch: 10 },
        { wch: 12 },
        { wch: 14 },
        { wch: 18 },
      ];
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        center.CostCenter.substring(0, 31)
      );
    });

    const outletName = selectedOutlet.replace(/\s+/g, "_");
    const tabSuffix = isAggregated ? "_aggregated" : "";
    XLSX.writeFile(
      wb,
      `cost_center_${outletName}_${startDate}_${endDate}${tabSuffix}.xlsx`
    );
  };

  const scrollToCenter = (name) => {
    const el = centerRefs.current[name];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const overallGrandTotal = data.reduce(
    (sum, c) => sum + Number(c.grand_total || 0),
    0
  );

  // Shared renderer for both Normal and Aggregated — layout is identical
  const renderCenterTables = (renderData, isAggregated) =>
    renderData.map((center, idx) => (
      <div
        key={center.CostCenter}
        ref={(el) => (centerRefs.current[center.CostCenter] = el)}
        className="mb-5"
      >
        <div
          key={idx}
          className="max-w-5xl mx-auto border rounded-lg shadow-sm overflow-hidden"
        >
          <div className="bg-slate-500 text-white px-4 py-2 font-semibold">
            Cost Center: {center.CostCenter}
          </div>

          <div className="max-h-[600px] overflow-y-auto border rounded tiny-scrollbar">
            <table className="w-full text-sm">
              <thead className="bg-slate-100 sticky top-0 z-10">
                <tr>
                  <th className="px-3 py-2 text-left">Group</th>
                  <th className="px-3 py-2 text-left">Item</th>
                  <th className="px-3 py-2 text-left">Brand</th>
                  <th className="px-3 py-2 text-right">Qty</th>
                  <th className="px-3 py-2 text-left">UOM</th>
                  <th className="px-3 py-2 text-right">
                    {isAggregated ? "Avg Rate" : "Rate"}
                  </th>
                  <th className="px-3 py-2 text-right">Total</th>
                </tr>
              </thead>

              <tbody>
                {(center.GroupWiseItemDetails || []).map((group, gIdx) => (
                  <React.Fragment key={gIdx}>
                    <tr className="bg-slate-200">
                      <td colSpan={7} className="px-3 py-2 font-semibold text-slate-700">
                        {group.GroupName}
                      </td>
                    </tr>

                    {group.items.map((item, iIdx) => (
                      <tr key={iIdx} className="border-t">
                        <td className="px-3 py-2"></td>
                        <td className="px-3 py-2">{item.ItemName}</td>
                        <td className="px-3 py-2">{item.BrandName || "-"}</td>
                        <td className="px-3 py-2 text-right">
                          {isAggregated
                            ? formatSalesValue(item.totalQty)
                            : item.Amount}
                        </td>
                        <td className="px-3 py-2">{item.UOM}</td>
                        <td className="px-3 py-2 text-right">
                          {isAggregated
                            ? formatSalesValue(item.avgRate)
                            : formatSalesValue(item.Rate)}
                        </td>
                        <td className="px-3 py-2 text-right font-medium">
                          {isAggregated
                            ? formatSalesValue(item.Total)
                            : formatSalesValue(item.Total)}
                        </td>
                      </tr>
                    ))}

                    <tr className="bg-slate-100 font-semibold">
                      <td colSpan={6} className="px-3 py-2 text-right">
                        Group Total
                      </td>
                      <td className="px-3 py-2 text-right">
                        {formatSalesValue(group.group_total)}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex justify-end max-w-5xl w-full mx-auto mt-2">
          <div className="bg-slate-500 font-semibold rounded-lg py-2 px-3 text-white">
            Grand Total: {formatSalesValue(center.grand_total)}
          </div>
        </div>
      </div>
    ));

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-grow">
        <div className="pt-4">
          {/* Filters */}
          <div className="max-w-5xl mx-auto mb-3">
            <div className="flex justify-between items-center mb-3">
              <div className="flex items-center gap-x-3">
                <label className="font-base font-poppins md:text-base">From:</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="text-xs md:text-base cursor-pointer border rounded px-3 py-2"
                />
              </div>

              <OutletSearch
                selectedOutlet={selectedOutlet}
                setSelectedOutlet={setSelectedOutlet}
                token={token}
              />

              <div className="flex items-center gap-x-3">
                <label className="font-base font-poppins md:text-base">To:</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="text-xs md:text-base cursor-pointer border rounded px-3 py-2"
                />
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex-1 flex justify-start">
                <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden">
                  {TABS.map((tab) => (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      disabled={data.length === 0 || loading || error}
                      className={`px-5 py-2 text-sm font-medium transition-colors
                        disabled:!bg-slate-100
                        disabled:!text-slate-500
                        disabled:!cursor-not-allowed
                        disabled:!hover:bg-slate-100
                        ${activeTab === tab
                          ? "bg-slate-600 text-white"
                          : "bg-white text-slate-600 hover:bg-slate-50"
                        }`}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex-1 flex justify-center">
                <button
                  onClick={handleCostCenter}
                  disabled={loading}
                  className="px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm transition"
                >
                  {loading ? "Loading..." : "Search"}
                </button>
              </div>

              <div className="flex-1 flex justify-end">
                <button
                  onClick={handleExportExcel}
                  disabled={!data.length}
                  className="px-4 py-2 rounded-md font-medium bg-green-100 text-green-800 hover:bg-green-200 hover:shadow-md text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Export To Excel
                </button>
              </div>
            </div>
          </div>

          {/* Loading */}
          {loading && (
            <div className="max-w-5xl mx-auto my-4 rounded-md bg-blue-50 p-4">
              <div className="flex gap-3 justify-center">
                <MdAutorenew className="h-5 w-5 text-blue-500 animate-spin" />
                <div className="text-blue-700">Fetching cost center data...</div>
              </div>
            </div>
          )}

          {/* Error */}
          {error && (
            <div className="max-w-5xl mx-auto my-4 rounded-md bg-red-50 p-4">
              <div className="flex gap-3 justify-center">
                <MdError className="h-5 w-5 text-red-400" />
                <div className="text-red-700">{error}</div>
              </div>
            </div>
          )}

          {!loading && data.length > 0 && (
            <>
              {/* Cost Center Summary — always visible */}
              <div className="max-w-sm mx-auto mt-2 border rounded-lg overflow-hidden shadow-sm mb-4">
                <div className="bg-slate-600 text-white px-4 py-2 font-semibold">
                  Cost Center Summary
                </div>
                <table className="w-full text-sm">
                  <thead className="bg-slate-100">
                    <tr>
                      <th className="px-3 py-2 text-left">Cost Center</th>
                      <th className="px-3 py-2 text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((center, i) => (
                      <tr
                        key={i}
                        onClick={() => scrollToCenter(center.CostCenter)}
                        className="border-t cursor-pointer hover:bg-slate-100"
                      >
                        <td className="px-3 py-2 font-medium text-blue-700 hover:underline">
                          {center.CostCenter}
                        </td>
                        <td className="px-3 py-2 text-right">
                          {formatSalesValue(center.grand_total)}
                        </td>
                      </tr>
                    ))}
                    <tr className="border-t bg-slate-200 font-semibold">
                      <td className="px-3 py-2 text-left">Grand Total</td>
                      <td className="px-3 py-2 text-right">
                        {formatSalesValue(overallGrandTotal)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Tables — same layout, different data source */}
              {renderCenterTables(displayData, activeTab === "Aggregated")}
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CostCenter;